import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import isGiftUrlLocationUtil from 'utils/location/is-gift-url'

export default function isGiftOrSelfGiftingUrlLocationUtil () {
  return (
    isGiftUrlLocationUtil() ||
    isSelfGiftingUrlLocationUtil()
  )
}
